export const environment = {
  production: false,
  serviceUrl: "https://dev-platform.weomni-test.com",
  projectId: "5edf67da3abbea0001c571fd",
  auth: {
    clientId: "live_webview",
    secret: "wuYyhj]cC$n|NSxu"
  }
};
